/**
 * Control system for heating - controls all heaters
 */

import Color from '../color.es6'
import Ren from '../ren-shape.es6'
import Element from './element.es6'

import Konva from 'konva'

export default class Heating extends Element {
  setDefaultShapes () {
    this.shapes = [
      new Ren.Circle({
        name: 'heating1',
        x: 0,
        y: 0,
        radius: 1.5,
        fill: Color.offlineGray,
        stroke: Color.offlineGray,
        strokeWidth: 0.5
      }),

      new Ren.Rect({
        name: 'heating2',
        x: -1.5,
        y: 0,
        width: 3,
        height: 25,
        stroke: Color.offlineGray,
        strokeWidth: 1,
        fill: Color.offlineGray
      }),

      new Ren.Circle({
        name: 'heating3',
        x: 0,
        y: 25,
        radius: 6,
        fill: Color.offlineGray,
        stroke: Color.offlineGray,
        strokeWidth: 1
      }),

      new Konva.Text({
        name: 'temperatureValue',
        x: 10,
        y: 15,
        text: 'N/A',
        fontSize: 13,
        fill: 'black'
      }),
      new Ren.Circle({
        name: 'onlineStatus',
        x: -10,
        y: 0,
        radius: 3,
        opacity: 1,
        fill: 'red'
      })
    ]
  }

  applyStatusOnShapes (newVariables, deviceTypes) {
    const status = newVariables || this.status
    super.applyStatusOnShapes(newVariables)

    const heatingColor = {
      0: Color.tBlue,
      1: 'red'
    }

    if (status.railTemp) {
      const railTemp = status.railTemp
        ? parseFloat(status.railTemp).toFixed(1)
        : ''
      this.changeShapeColor(Color.sigBack)
      this.modifyShape('temperatureValue', 'text', `${railTemp} °C`)
    }

    if (status.heating) {
      const color = heatingColor[status['heating']]
      this.changeShapeColor(color)
    }
  }

  changeShapeColor (color) {
    this.modifyShape('heating1', 'fill', color)
    this.modifyShape('heating1', 'stroke', color)
    this.modifyShape('heating2', 'fill', color)
    this.modifyShape('heating2', 'stroke', color)
    this.modifyShape('heating3', 'fill', color)
    this.modifyShape('heating3', 'stroke', color)
  }
}
